import { Chip, ClickAwayListener, Grid } from "@material-ui/core";
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { languages } from "i18n";
import React, { Fragment } from "react";
import { withTranslation } from "react-i18next";
import packageJson from '../../../package.json';
import { checkLoggedIn, getUser, login, logout } from "../../config/azureConfig";
import { getIcon } from "../../icon/icon";
import styles from "./AccountPopover.module.scss"; // Import css modules stylesheet as styles

class AccountPopover extends React.Component {
  constructor() {
    super();

    this.state = {
      accountPopoverShowing: false,
      languagePopoverShowing: false,
      loggedIn: false
    };
  }

  componentDidMount() {
    checkLoggedIn((success) => {
      this.setState({ loggedIn: success })
    })
  }

  componentDidUpdate() {
    checkLoggedIn((success) => {
      if (this.state.loggedIn != success) {
        this.setState({ loggedIn: success })
      }
    })
  }

  switchTheme() {
    let theme = document.documentElement.getAttribute("data-theme");

    if (theme === "light") {
      document.documentElement.setAttribute("data-theme", "dark");
    } else {
      document.documentElement.setAttribute("data-theme", "light");
    }

    this.forceUpdate();
  }

  handleClickAway() {
    if (this.setState({ accountPopoverShowing: false, languagePopoverShowing: false }));
  }

  renderLangaugeSelection() {
    const { t, i18n } = this.props
    return (
      <div
        onClick={() =>
          this.setState({
            languagePopoverShowing: !this.state.languagePopoverShowing,
            accountPopoverShowing: false
          })
        }
        className={styles.appBarButton}
      >
        <Chip className={styles.environmentChip} variant="outlined" color="default" label={t("common.language")} />
      </div>

    )
  }

  switchLanguage(languageCode) {
    const { i18n } = this.props
    i18n.changeLanguage(languageCode)
  }

  render() {
    const { t, i18n } = this.props

    return (
      <Fragment>
        <div className={styles.background + ' ' + (this.state.accountPopoverShowing || this.state.languagePopoverShowing ? styles.showing : styles.hidden)} />
        <ClickAwayListener onClickAway={() => this.handleClickAway()}>
          <div className={styles.accountPopoverContainer}>
            <div
              onClick={() =>
                this.setState({
                  accountPopoverShowing: !this.state.accountPopoverShowing,
                  languagePopoverShowing: false
                })
              }
              className={styles.appBarButton}
            >
              {getUser()?.userName || t("common.not-logged-in")}
            </div>
            <div className={styles.button}>
              <div
                className={
                  styles.accountPopover +
                  " " +
                  (this.state.languagePopoverShowing
                    ? styles.active
                    : styles.inactive)
                }
              >
                <List component="nav" aria-label="main mailbox folders">
                  {i18n.options.fallbackLng.sort().map((item) => (
                    <ListItem key={item} button onClick={() => this.switchLanguage(item)}>
                      <ListItemText primary={t(`common.${item}`)} />
                    </ListItem>
                  ))}

                </List>
              </div>
            </div>

            <div className={styles.button}>
              <div
                className={
                  styles.accountPopover +
                  " " +
                  (this.state.accountPopoverShowing
                    ? styles.active
                    : styles.inactive)
                }
              >
                <List component="nav" aria-label="main mailbox folders">
                  <ListItem button onClick={() => this.switchTheme()}>
                    <ListItemIcon>
                      {getIcon("bulb.svg", styles.icon)}
                    </ListItemIcon>
                    <ListItemText primary={t("common.theme")} />
                  </ListItem>
                  {
                    this.state.loggedIn ?
                      <ListItem button onClick={() => logout()}>
                        <ListItemIcon>
                          {getIcon("exit.svg", styles.icon)}
                        </ListItemIcon>
                        <ListItemText primary={t("common.logout")} />
                      </ListItem> :
                      <ListItem button onClick={() => login()}>
                        <ListItemIcon>
                          {getIcon("exit.svg", styles.icon)}
                        </ListItemIcon>
                        <ListItemText primary={t("common.login")} />
                      </ListItem>
                  }
                  <ListItem button onClick={() =>
                    this.setState({
                      languagePopoverShowing: !this.state.languagePopoverShowing,
                      accountPopoverShowing: false
                    })
                  }>
                    <ListItemIcon>
                      {getIcon("world.svg", styles.icon)}
                    </ListItemIcon>
                    <ListItemText primary={t("common.language")} />
                  </ListItem>
                  <ListItem >
                    <Grid container spacing={1}>
                      <Grid item>
                        <Chip variant="outlined" label={process.env.REACT_APP_FLAVOUR} />
                      </Grid>
                      <Grid item>
                        <Chip variant="outlined" label={process.env.REACT_APP_ENVIRONMENT} />
                      </Grid>
                      <Grid item>
                        <Chip variant="outlined" label={packageJson.version} />
                      </Grid>
                      <Grid item>
                        <Chip variant="outlined" label={process.env.REACT_APP_BUILD_NUMBER} />
                      </Grid>
                    </Grid>
                  </ListItem>
                </List>
              </div>
            </div>
          </div>
        </ClickAwayListener>
      </Fragment >
    );
  }
}

export default withTranslation()(AccountPopover)